mutation CompanyCorporateYearUpdate($input: CompanyCorporateYearUpdateInput!) {
  companyCorporateYearUpdate(input: $input) {
    companyCorporateYear {
      id
      fiscalYear
      startDate
      endDate
      isYearOpen
      isEntryAllowed
      _rowTimestamp
      _isUpdatable
      _isDeletable
      companyCorporatePeriodsByFiscalYearId {
        nodes {
          id
          fiscalYearId
          fiscalPeriod
          startDate
          endDate
          isPeriodOpen
          isEntryAllowed
          _isUpdatable
          _isDeletable
          _rowTimestamp
          corporateYear {
            id
            _rowTimestamp
          }
        }
        totalCount
      }
    }
  }
}
